export default () => import(/* webpackChunkName: 'coffee/app/product-health-detail/home' */ './Home');
